import { usePartnerTab } from "./usePartnerTab";
import SmruHero from "./sections/SmruHero";
import SmruTrustBar from "./sections/SmruTrustBar";
import SmruProblem from "./sections/SmruProblem";
import SmruMentors from "./sections/SmruMentors";
import SmruComparison from "./sections/SmruComparison";
import SmruStats from "./sections/SmruStats";
import SmruSpecializations from "./sections/SmruSpecializations";
import SmruHiring from "./sections/SmruHiring";
import SmruTimeline from "./sections/SmruTimeline";
import SmruPromises from "./sections/SmruPromises";
import SmruCareers from "./sections/SmruCareers";
import SmruFounder from "./sections/SmruFounder";
import SmruAdmissions from "./sections/SmruAdmissions";
import SmruFaq from "./sections/SmruFaq";
import SmruFooter from "./sections/SmruFooter";

/**
 * AI.Prof × St. Mary's University (SMRU) standalone partnership landing page.
 * Route: /RFC — renders with NO global site chrome (see App.js Shell).
 * Self-contained: brings its own slim dual-brand sticky header and footer.
 */
export default function SMRUPage() {
    usePartnerTab(
        "AI.Prof × St. Mary's University — India's First AI-Powered B.Tech",
    );

    return (
        <div className="bg-white text-gray-900 font-sans antialiased selection:bg-aiblue selection:text-white">
            <main>
                <SmruHero />
                {/* <SmruTrustBar /> */}
                <SmruProblem />
                <SmruMentors />
                {/* <SmruComparison /> */}
                {/* <SmruStats /> */}
                <SmruSpecializations />
              
                <SmruTimeline />
                <SmruPromises />
                <SmruHiring />
                {/* <SmruCareers /> */}
                <SmruFounder />
                <SmruAdmissions />
                <SmruFaq />
            </main>
            <SmruFooter />
        </div>
    );
}
